import {getTmdbImage} from "../../../../utils/consts";
import {useSelector} from "react-redux";
import users from "../../../users";
import {getBackgroundColor} from "../../../../utils/utils";
import './itemDetailsToView.css';
import {useIntl} from "react-intl";

const ItemDetailsToView = ({
                               episode,
                               item,
                               onClick,
                               iconClass,
                               tag,
                               description,
                               title,
                               posterPath,
                               hover = true,
                               width = 100,
                               aspectRatio = 3 / 4,
                               hideShadow = false
                           }) => {
    const darkMode = useSelector(users.selectors.isDarkMode);
    const intl = useIntl();

    return (
        <button className="item-details-view" onClick={() => onClick?.()} style={{
            position: 'relative',
            border: 'none',
            display: 'flex',
            flexDirection: 'column',
            borderRadius: 5,
            backgroundColor: getBackgroundColor(darkMode),
            userSelect: 'none',
        }}>
            {tag && <span
                className="badge text-bg-info"
                style={{
                    position: 'absolute',
                    top: -2,
                    left: -2,
                    zIndex: 3
                }}>{tag}</span>}
            <div className={hover ? "item-details-view__over-info" : "item-details-view__over-info__no-hover"}>
                <div className="item-details-view__over-info__div" style={{
                    zIndex: 2,
                    color: 'white',
                    display: 'flex',
                    flexDirection: 'column',
                    justifyContent: 'space-between',
                }}>
                    <div>

                    </div>
                    <div>
                        <i className={`${iconClass ?? "fa-regular fa-circle-play"} fa-2xl`}></i>
                    </div>
                    <div style={{height: "fit-content"}}>
                        {(description || title) && <>
                            <div>
                                {title}
                            </div>
                            <div style={{
                                fontSize: 12,
                                paddingBottom: 5,
                            }}>
                                {description}
                            </div>
                        </>}
                        {episode && !description && !title && <>
                            <div>
                                Ep. {episode?.episode_number}
                            </div>
                            <div style={{
                                fontSize: 12,
                                paddingBottom: 5,
                            }}>
                                {intl.formatMessage({id: "squadflix.serie.season"})} {episode?.season_number}
                            </div>
                        </>}
                        {!episode && !description && !title && <>
                            <div>
                                {intl.formatMessage({id: "squadflix.movie"})}
                            </div>
                            {item.runtime && <div style={{
                                fontSize: 12,
                                paddingBottom: 5,
                            }}>
                                {item.runtime}min
                            </div>}
                        </>}
                    </div>
                </div>
                {!hideShadow &&
                    <div className="item-details-view__over-info__div item-details-view__over-info__shadow"></div>}
            </div>
            <img src={posterPath ?? getTmdbImage(item.poster_path, "w200")} alt={item?.name}
                 style={{
                     width: width,
                     aspectRatio: aspectRatio,
                     objectFit: "cover",
                     backgroundColor: "white",
                     borderRadius: 5
                 }}/>
        </button>
    );
}

export default ItemDetailsToView;
